module.exports = __webpack_public_path__ + "static/media/zohoLogo.fe295b0d.svg";